export const InstallTabs = {
  flow: 'x',
  align: 'end',
  gap: 'B1',
  margin: 'C1 - -',
  childProps: {
    isActive: (el, s) => s.installTab === el.key,
    theme: 'transparent',
    // Was a persistent 3px bottom border on the active tab, painted with a
    // raw CSS var (`--document-dark-background`) instead of a token —
    // underline-as-chrome, banned by design-direction.md §8 / DESIGN_LANGUAGE
    // §2.5 stroke policy. Mirrors brand TabsLink.js's identical fix: drop the
    // border, let the active state read from ink alone (color + weight
    // below). Padding rebalanced from the old bottom-heavy '0 0 A' (shaped to
    // clear the border) to symmetric 'Z1 A' now that there is nothing to
    // clear.
    round: '0',
    padding: 'Z1 A',
    align: 'end',
    transition: 'A, defaultBezier',
    transitionProperty: 'color, font-weight',
    // Real tab semantics for assistive tech (brief §"Real semantics") —
    // the active tab was conveyed only visually via .isActive. `role` is a
    // flat first-class prop (audit_component FA105 — brand TabsLink.js
    // still wraps it in `attr:`, a pre-existing defect out of scope here
    // since brand/ is read-only); `aria-selected` stays in `attr` since a
    // hyphenated aria-* key has no flat form.
    role: 'tab',
    attr: {
      'aria-selected': (el, s) => String(!!el.call('exec', el.isActive, el))
    },
    ':hover': {
      color: 'title'
    },
    '.isActive': {
      color: 'title',
      // 'bold' silently renders as 700 in this face (no 600) — spelled out
      // as the real token per the {400,500,700} weight law (DESIGN_LANGUAGE
      // §5.2).
      fontWeight: '700'
    },
    onClick: (ev, el, s) => {
      s.update({
        installTab: el.key
      })
      el.call('setCookie', 'installTab', el.key)
    }
  },
  childExtends: 'Button',
  Development: {
    text: '{{ publish.envs.development | polyglot }}'
  },
  Domain: {
    extends: 'SubscribeButton',
    Text: {
      order: '-1',
      text: '{{ learn.install.domain | polyglot }}'
    }
  },
  Live: {
    text: '{{ editor.import.liveWebsite | polyglot }}'
  }
}
